import * as z from 'zod';
import * as ba from './base';
import { SCRIPT_SCHEMA } from '../scripting';
export class PowerAction extends ba.Action {
    static get manifest() {
        return {
            name: 'power',
            schema: z.object({
                x: z.union([z.number(), SCRIPT_SCHEMA()]),
                y: z.union([z.number(), SCRIPT_SCHEMA()])
            })
        };
    }
    async handle(event, args) {
        const result = Math.pow(args.x, args.y);
        await this.dispatch('success', { result });
        return { result };
    }
}
//# sourceMappingURL=power.js.map